module.exports = __webpack_public_path__ + "img/space-24.bfd4266c.svg";